import { FeedbackType } from '@chegg-wt/core-wa/types'

export const highlightStyles = (type: keyof typeof FeedbackType) => {
  return type === FeedbackType.REWRITE
    ? { PADDING_BOTTOM: 'padding: 8px 0' }
    : { PADDING_BOTTOM: 'padding: 4px 0' }
}

export const HighlightColors = {
  [FeedbackType.GRAMMAR]: '#b9e9e1',
  [FeedbackType.PARAPHRASE]: '#d1eaff',
  [FeedbackType.REWRITE]: '#eeeef1',
}
